<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div>
        <ais-instant-search
            :search-client="searchClient"
            index-name="instant_search" id="algolia-instant-search-demo">

            <!-- AIS CONFIG -->
            <ais-configure :hits-per-page.camel="9" />

            <div class="algolia-header mb-4">
                <div class="flex md:items-end items-center justify-between flex-wrap">
                    <!-- TOGGLE SIDEBAR BUTTON -->
                    <feather-icon
                        class="inline-flex lg:hidden cursor-pointer mr-4"
                        icon="MenuIcon"
                        @click.stop="toggleFilterSidebar" />

                    <p class="lg:inline-flex hidden font-semibold algolia-filters-label">FILTROS</p>

                    <div class="flex justify-between items-end flex-grow">
                        <!-- Stats -->
                        <ais-stats>
                            <p slot-scope="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }" class="font-semibold md:block hidden">
                                <!-- {{ nbHits }} results found in {{ processingTimeMS }}ms -->
                            </p>
                        </ais-stats>

                        <div class="flex flex-wrap">

                            <!-- ITEMS ORDER -->
                            <span class="breadcrumb-separator mx-2" style="align-self: center">ORDENAR:</span>
                            <vs-select 
                              class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-25" 
                              v-model="itemsOrder"
                              @change="changeItemOrder($event)">  
                                <vs-select-item 
                                  :key="index" 
                                  :value="item.value" 
                                  :text="item.text" 
                                  v-for="(item,index) in optionsItemsOrder" />
                            </vs-select>

                            <!-- ITEMS PER PAGE -->
                            <span class="breadcrumb-separator mx-2" style="align-self: center">MOSTRAR:</span>
                            <vs-select 
                              class="mr-4 vs-input-shadow-drop vs-select-no-border d-theme-input-dark-bg w-24" 
                              v-model="itemsPage"
                              @change="changeItemPage($event)">  
                                <vs-select-item 
                                  :key="index" 
                                  :value="item.value" 
                                  :text="item.text" 
                                  v-for="(item,index) in optionsItemsPage" />
                            </vs-select>
                            
                            <!-- ITEM VIEW - GRID/LIST -->
                            <div>
                                <feather-icon
                                    icon="GridIcon"
                                    @click="modeshow('item-grid-view')" 
                                    class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
                                    :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}" />
                                <feather-icon
                                    icon="ListIcon"
                                    @click="modeshow('item-list-view')" 
                                    class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden sm:inline-flex"
                                    :svgClasses="{'text-primary stroke-current': currentItemView == 'item-list-view'}" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="algolia-content-container" class="relative clearfix">
                <vs-sidebar
                    class="items-no-padding vs-sidebar-rounded background-absolute"
                    parent="#algolia-content-container"
                    :click-not-close="clickNotClose"
                    :hidden-background="clickNotClose"
                    v-model="isFilterSidebarActive">

                    <div class="p-6 filter-container">

                        <!-- MULTI RANGE -->
                        <h6 class="font-bold mb-3">RANGO MÚLTIPLE</h6>
                        <ais-numeric-menu attribute="price" :items="numericItems">
                            <ul slot-scope="{ items, refine, createURL }">
                                <li
                                    v-for="item in items"
                                    :key="item.value"
                                    class="flex items-center cursor-pointer py-1"
                                    @click="searchRange(items, item)">

                                    <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': item.isRefined}, 'h-5 w-5']" />
                                    <span class="ml-2" :class="{'text-primary': item.isRefined}">{{ item.label }}</span>
                                </li>
                            </ul>
                        </ais-numeric-menu>

                        <vs-divider />

                        <!-- CATEGORIES -->
                        <h6 class="font-bold mb-4">CATEGORÍAS</h6>
                        <ais-hierarchical-menu :attributes="algoliaCategories">
                            <div slot-scope="{
                              items,
                              refine,
                            }">
                                <ul>
                                    <li v-for="item in categories" 
                                      :key="item.codcla" 
                                      class="flex items-center cursor-pointer py-1" 
                                      @click="searchClass(categories, item)"
                                    >
                                        <feather-icon icon="CircleIcon" :svgClasses="[{ 'text-primary fill-current': item.codcla == categori}, 'h-5 w-5']" />
                                        <span class="ml-2" :class="{'text-primary': item.isRefined}">{{ item.nomcla +' ('+item.cancla+')' }}</span>
                                        
                                    </li>
                                </ul>
                            </div>
                        </ais-hierarchical-menu>

                        <vs-divider />

                        <ais-clear-refinements class="flex justify-center">
                            <vs-button class="w-full" slot-scope="{ canRefine, refine, createURL }" @click.prevent="refine" :disabled="false" @click="clearFilterRange()">REMOVER FILTROS</vs-button>
                        </ais-clear-refinements>
                    </div>
                </vs-sidebar>

                <!-- RIGHT COL -->
                <div :class="{'sidebar-spacer-with-margin': clickNotClose}">

                    <!-- SEARCH BAR -->
                    <ais-search-box>
                        <div slot-scope="{ currentRefinement, isSearchStalled, refine }">
                            <div class="relative mb-8">

                                <!-- SEARCH INPUT -->
                                <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg" placeholder="BUSCAR" v-model="searchText" @input="search($event)"  size="large" />

                                <!-- SEARCH LOADING -->
                                <p :hidden="!isSearchStalled" class="mt-4 text-grey">
                                  <feather-icon icon="ClockIcon" svgClasses="w-4 h-4" class="mr-2 align-middle" />
                                  <span>Loading...</span>
                                </p>

                                <!-- SEARCH ICON -->
                                <div slot="submit-icon" class="absolute top-0 right-0 py-4 px-6" v-show="!currentRefinement">
                                    <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" />
                                </div>

                                <!-- CLEAR INPUT ICON -->
                                <div slot="reset-icon" class="absolute top-0 right-0 py-4 px-6" v-show="currentRefinement">
                                    <feather-icon icon="XIcon" svgClasses="h-6 w-6 cursor-pointer" @click="refine('')" />
                                </div>
                            </div>
                        </div>
                    </ais-search-box>

                    <!-- SEARCH RESULT -->
                    <ais-hits>
                        <div slot-scope="{ items }">

                            <!-- GRID VIEW -->
                            <template v-if="currentItemView == 'item-grid-view'">
                                <div class="items-grid-view vx-row match-height">
                                    <div class="vx-col lg:w-1/5 md:w-1/4 sm:w-1/3 w-full" v-for="item in related_items" :key="item.codart">

                                        <item-grid-view :item="item">

                                            <!-- SLOT: ACTION BUTTONS -->
                                            <template slot="action-buttons">
                                                <div class="flex flex-wrap">
                                                    <div
                                                        class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                                                        @click="cartButtonClicked(item)">
                                                        <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4" />

                                                        <span class="text-sm font-semibold ml-2" v-if="isInCart(item.objectID)">VER EN CARRITO</span>
                                                        <span class="text-sm font-semibold ml-2" v-else>AÑADIR AL CARRITO</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </item-grid-view>

                                    </div>
                                </div>
                            </template>

                            <!-- LIST VIEW -->
                            <template v-else>
                                <div class="items-list-view mb-base" v-for="item in related_items" :key="item.codart">

                                    <item-list-view :item="item">

                                        <!-- SLOT: ACTION BUTTONS -->
                                        <template slot="action-buttons">
                                            <div
                                                class="item-view-secondary-action-btn bg-primary p-3 rounded-lg flex flex-grow items-center justify-center text-white cursor-pointer"
                                                @click="cartButtonClicked(item)">
                                                <feather-icon icon="ShoppingCartIcon" svgClasses="h-4 w-4" />

                                                <span class="text-sm font-semibold ml-2" v-if="isInCart(item.objectID)">VER EN CARRITO</span>
                                                <span class="text-sm font-semibold ml-2" v-else>AÑADIR AL CARRITO</span>
                                            </div>
                                        </template>
                                    </item-list-view>

                                </div>
                            </template>
                        </div>
                    </ais-hits>

                    <!-- PAGINATION -->
                    <ais-pagination>
                        <div slot-scope="{
                                currentRefinement,
                                nbPages,
                                pages,
                                isFirstPage,
                                isLastPage,
                                refine,
                                createURL
                            }"
                        >

                        <vs-pagination

                            :total="total_rows"
                            :max="7"
                            :value="currentRefinement + 1"
                            v-model="currentx" 
                            @input="(val) => { 
                               products(val - 1)  
                              }" />
                        </div>
                    </ais-pagination>

                </div>
            </div>
        </ais-instant-search>
    </div>
</template>

<script>
import {
  AisClearRefinements,
  AisConfigure,
  AisHierarchicalMenu,
  AisHits,
  AisInstantSearch,
  AisNumericMenu,
  AisPagination,
  AisRangeInput,
  AisRatingMenu,
  AisRefinementList,
  AisSearchBox,
  AisSortBy,
  AisStats
} from 'vue-instantsearch'
import algoliasearch from 'algoliasearch/lite'
import axios from "axios";
import auth from '@/auth/authService'
import Vue from "vue";
import {mapMutations, mapState, mapActions} from 'vuex'
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);

Vue.use(DropDownListPlugin);

var token = auth.getToken()
var rucced = null;
var codemp = null;
var parametros = null;
var item_lispre = 1;
var item_client = null;

export default {
  components: {
    ItemGridView: () => import('./components/ItemGridView.vue'),
    ItemListView: () => import('./components/ItemListView.vue'),
    AisClearRefinements,
    AisConfigure,
    AisHierarchicalMenu,
    AisHits,
    AisInstantSearch,
    AisNumericMenu,
    AisPagination,
    AisRangeInput,
    AisRatingMenu,
    AisRefinementList,
    AisSearchBox,
    AisSortBy,
    AisStats
  },
  data () {
    return {
      searchClient: algoliasearch(
        'latency',
        '6be0576ff61c053d5f9a3225e2a90f76'
      ),
      // Filter Sidebar
      isFilterSidebarActive: true,
      clickNotClose: true,
      currentItemView: 'item-grid-view',
      total_rows: 1,
      numericItems: [
        { label: 'TODOS', start: 0, end: 1000000 },
        { label: '<= $10', start: 0, end: 10 },
        { label: '$10 - $100', start: 10, end: 100 },
        { label: '$100 - $500', start: 100, end: 500 },
        { label: '>= $500', start: 500, end: 1000000 }
      ],
           algoliaCategories: [
        'codcla',
        // 'hierarchicalCategories.lvl1',
        // 'hierarchicalCategories.lvl2',
        // 'hierarchicalCategories.lvl3'
      ],
      related_items: [],
      item_params: null,
      item_client: null,
      searchText: '',
      rangeStart: 0,
      rangeEnd: 1000000,
      selectionFields: { text: "text", value: "value" },
      itemsPage: null,
      optionsItemsPage: [
        { text: '12', value: 12 },
        { text: '24', value: 24 },
        { text: '36', value: 36 },
      ],
      itemsOrder: null,
      optionsItemsOrder: [
        { text: 'CÓDIGO ASC', value: 'codart ASC' },
        { text: 'CÓDIGO DESC', value: 'codart DESC' },
        { text: 'NOMBRE ASC', value: 'nomart ASC' },
        { text: 'NOMBRE DESC', value: 'nomart DESC' },
      ],
      categories: [],
      categori: null,
      currentx: 1
    }
  },
  computed: {
    ...mapState('eCommerce',['cItemView', 'clientState', 'ruccedState', 'codempState', 'paramState', 'lispreState', 'productState', 'total_pages', 'itemsPageState', 'cartItems']),
    toValue () {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max
      ]
    },

    // GRID VIEW
    isInCart () {
      return (itemId) => this.$store.getters['eCommerce/isInCart'](itemId)
    },
    windowWidth () { return this.$store.state.windowWidth }
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth()
    }
  },
  methods: {
    refin(){
    for(var i in this.categories){
            this.categories[i].isRefined = false
          }
    },
    ...mapActions('eCommerce', ['getClient', 'getProducts']),
    ...mapMutations('eCommerce', ['UPDATE_VIEW_TYPE', 'UPDATE_RUCCED', 'UPDATE_CODEMP', 'UPDATE_PARAMS', 'UPDATE_LISPRE', 'UPDATE_DESART', 'UPDATE_DESCLI', 'UPDATE_itemsPageState']),
    products(pagina){
      var payloadProducts = [];
      payloadProducts.codemp = this.codempState;
      payloadProducts.pagina = pagina;
      payloadProducts.codcla = this.categori || '';
      payloadProducts.search = this.searchText;
      payloadProducts.maxpre = this.rangeEnd;
      payloadProducts.minpre = this.rangeStart;
      payloadProducts.orden = this.itemsOrder || this.paramState.ec_ordart;
      payloadProducts.lispre = this.lispreState
      payloadProducts.exis = this.paramState.ec_exiact;
      payloadProducts.itemspage = this.itemsPage;
      payloadProducts.token = auth.getToken();
      this.getProducts(payloadProducts).then(
      response => { 
        this.related_items = this.productState;
        this.total_rows = this.total_pages;
      })    
    },
    setParams(clients, params){
      if(params.ec_lispre == 'C'){ 
        this.UPDATE_LISPRE(clients.lispre ? clients.lispre : 1)
      }else{
        this.UPDATE_LISPRE(params.ec_lispre);
      }
      if(params.ec_desart == 'S'){
        this.UPDATE_DESART(this.lispreState)
      }else{
        this.UPDATE_DESART(0)
      }
      if(params.ec_descli == 'S'){
        this.UPDATE_DESCLI(clients.descu ? clients.descu : 1)
      }else{
        this.UPDATE_DESCLI(0)
      }
    },
    search(itema){
      this.searchText = itema;
      this.products(0)
      this.currentx = 1
    },
    changeItemPage(items){
      this.itemsPage = items; 
      this.UPDATE_itemsPageState(items);
      this.products(0);
      this.currentx = 1
    },
    changeItemOrder(items){
      this.itemsOrder = items; 
      // this.UPDATE_itemsPageState(items);
      this.products(0);
      this.currentx = 1
    },
    searchRange(items, item){

      for(var i in items){
        items[i].isRefined = false
      }
      item.isRefined = true
      var label = item.label;
      if(label == 'TODOS'){
        this.rangeStart= 0;
        this.rangeEnd= 1000000;
      } else if(label == '<= $10'){
        this.rangeStart= 0;
        this.rangeEnd= 10;
      } else if(label == '$10 - $100'){
        this.rangeStart= 10;
        this.rangeEnd= 100;
      } else if(label == '$100 - $500'){
        this.rangeStart= 100;
        this.rangeEnd= 500;
      } else if(label == '>= $500'){
        this.rangeStart= 500;
        this.rangeEnd= 1000000;
      }
      this.products(0);
      this.currentx = 1

    },
    searchClass(items, item){

      for(var i in items){
        items[i].isRefined = false
      }
      item.isRefined = true
      this.categori = item.codcla
      this.products(0);
      this.currentx = 1

    },
    clearFilterRange(){
      this.rangeStart= 0;
      this.rangeEnd= 1000000;
      this.categori = null;
      for(var i in this.categories){
        this.categories[i].isRefined = false
      }
      this.products(0);
      this.currentx = 1
    },
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }
    },

    // GRID VIEW - ACTIONS
    toggleFilterSidebar () {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart (item) {
      if(this.paramState.ec_maxren == "S"){
        this.$store.dispatch('eCommerce/additemInCart', item)
        if(this.cartItems.length > this.paramState.ec_numren){
          this.$vs.notify({
            title: 'Error',
            text: 'Número máximo de items en el carrito: ' + this.paramState.ec_numren,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      }else if(this.paramState.ec_maxren == "B"){
        if(this.cartItems.length < this.paramState.ec_numren){
          this.$store.dispatch('eCommerce/additemInCart', item)
        }else{
          this.$vs.notify({
            title: 'Error',
            text: 'Número máximo de items en el carrito: ' + this.paramState.ec_numren,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        }
      }else{
        this.$store.dispatch('eCommerce/additemInCart', item)
      }

    },
    cartButtonClicked (item) {
      this.isInCart(item.objectID) ? this.$router.push('/apps/eCommerce/checkout').catch(() => {}) : this.additemInCart(item)
    }, 
    modeshow(mode){ 
      this.currentItemView = mode; 
      this.UPDATE_VIEW_TYPE(mode)
    }, 
  },
  created () {
    this.setSidebarWidth();
    this.currentItemView = this.cItemView || 'item-grid-view';
    this.itemsPage = this.itemsPageState || 12;
    this.categories = JSON.parse(localStorage.getItem("artcla"));
    this.UPDATE_RUCCED(localStorage.getItem("rucced"));
    this.UPDATE_CODEMP(localStorage.getItem("codemp"));
    this.UPDATE_PARAMS(JSON.parse(localStorage.getItem("parcli")));
    this.itemsOrder = this.paramState.ec_ordart || 'codart ASC';
    var payloadClients = [];
    payloadClients.rucced = this.ruccedState;
    payloadClients.codemp = this.codempState;
    payloadClients.token = auth.getToken();
    this.getClient(payloadClients).then(
      response => { 
        this.setParams(this.clientState, this.paramState)
        // this.products(0)
      })
  }
}

</script>


<style lang="scss">
#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #algolia-content-container {

    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: .5rem;
    }

    .vs-sidebar--items {
      border-radius: .5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}

@import "../../../../node_modules/@syncfusion/ej2-base/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css";
@import "../../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css";

</style>

